/**
 * Moves focus into a header menu that just opened (ENG-840): to its first
 * actionable item. When the menu is already on screen nothing scrolls;
 * otherwise (an inline panel below the fold on a short window) it scrolls into
 * view, without smooth scrolling, so reduced motion and photosensitivity mode
 * see no animation.
 */
export const focusFirstIn = (panel) => {
  if (!panel) return;
  const target = panel.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])') ?? panel;
  const rect = panel.getBoundingClientRect?.();
  const inView = !rect || (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
  if (target === panel && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
  if (!inView) panel.scrollIntoView?.({ block: 'nearest' });
};
